module.exports = __webpack_public_path__ + "static/media/sacks.eb66a071.png";